var map = {
	"./Fomo4D.md": 1349,
	"./Fomo4D_complete.md": 1350,
	"./MorganStark.md": 1351,
	"./MorganStark_complete.md": 1352,
	"./aliencodex.md": 1353,
	"./aliencodex_complete.md": 1354,
	"./bank.md": 1355,
	"./bank_complete.md": 1356,
	"./coinflip.md": 1357,
	"./coinflip_complete.md": 1358,
	"./crosslinkShip.md": 1359,
	"./crosslinkShip_complete.md": 1360,
	"./delegate.md": 1361,
	"./delegate_complete.md": 1362,
	"./denial.md": 1363,
	"./denial_complete.md": 1364,
	"./dragon.md": 1365,
	"./dragon_complete.md": 1366,
	"./elevator.md": 1367,
	"./elevator_complete.md": 1368,
	"./encrypt.md": 1369,
	"./encrypt_complete.md": 1370,
	"./fakeFibonacci.md": 1371,
	"./fakeFibonacci_complete.md": 1372,
	"./fallback.md": 1373,
	"./fallback_complete.md": 1374,
	"./fallout.md": 1375,
	"./fallout_complete.md": 1376,
	"./force.md": 1377,
	"./force_complete.md": 1378,
	"./freeshop.md": 1379,
	"./freeshop_complete.md": 1380,
	"./gatekeeper1.md": 1381,
	"./gatekeeper1_complete.md": 1382,
	"./gatekeeper2.md": 1383,
	"./gatekeeper2_complete.md": 1384,
	"./instances.md": 1385,
	"./instances_complete.md": 1386,
	"./king.md": 1387,
	"./king_complete.md": 1388,
	"./locked.md": 1389,
	"./locked_complete.md": 1390,
	"./magicnum.md": 1391,
	"./magicnum_complete.md": 1392,
	"./naughtcoin.md": 1393,
	"./naughtcoin_complete.md": 1394,
	"./paperScissorsStone.md": 1395,
	"./paperScissorsStone_complete.md": 1396,
	"./preservation.md": 1397,
	"./preservation_complete.md": 1398,
	"./privacy.md": 1399,
	"./privacy_complete.md": 1400,
	"./recovery.md": 1401,
	"./recovery_complete.md": 1402,
	"./reentrancy.md": 1403,
	"./reentrancy_complete.md": 1404,
	"./shop.md": 1405,
	"./shop_complete.md": 1406,
	"./strongBox.md": 1407,
	"./strongBox_complete.md": 1408,
	"./telephone.md": 1409,
	"./telephone_complete.md": 1410,
	"./university.md": 1411,
	"./university_complete.md": 1412,
	"./vault.md": 1413,
	"./vault_complete.md": 1414,
	"./ventureCapital.md": 1415,
	"./ventureCapital_complete.md": 1416
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 241;



//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels ^\.\/.*$
// module id = 241
// module chunks = 0